import React, { useEffect, useState } from 'react';
import { Button, Col, Row } from 'reactstrap';
import { useLocation, useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilter } from '@fortawesome/free-solid-svg-icons';
import moment from 'moment';

//Context
import { useAuth } from '../../../context/auth';

//Components
import TabelaListagem from "../../../components/TabelaListagem/TabelaListagem";
import TextField from '../../../components/TextField';
import SolicitacaoFiscalizacaoStepper from './components/DemandasStepper';

//Helpers
import { showMessage } from '../../../helpers/message';
import { objCampo, validarCampos } from '../../../helpers/ValidadorDeCampos';

//Constants
import { actionsTable } from '../../../constants/MaterialTable';

//API
import tipoDeFiscalizacao_api from '../../../api/tipoDeFIscalizacao_api';
import solicitacaoFiscalizacao_api from '../../../api/solicitacaoFiscalizacao_api';

function SolicitacaoFiscalizacao() {
    const { setLoading } = useAuth();

    const navigate = useNavigate();

    //Controle dos dados que vem na rota
    const location = useLocation();

    //Filtros que vem da location
    const { filtros } = location.state ? location.state : {};

    //State para pegar lista dos tipos de fiscalizacao
    const [listTipoDeFiscalizacao, setListTipoDeFiscalizacao] = useState([]);

    //Opções do campo de situação dos filtros
    const optionsSituacao = [
        { label: "Pendente", value: "Pendente" },
        { label: "Executado", value: "Executado" },
        { label: "Finalizado sem fiscalização", value: "Finalizado sem fiscalização" },
        { label: "Agrupado", value: "Agrupado" },
    ]

    //State para consultar o tipo de fiscalização
    const [consultaTipoFiscalizacao, setConsultaFiscalizacao] = useState({
        tipoFiscalizacao_id: "",
        dataInicial: "",
        dataFinal: ""
    });

    //State para pegar a lista de fiscalização pelo filtro
    const [listaFiscalizacao, setListaFiscalizacao] = useState([]);

    //State para editar a fiscalização
    const [fiscalizacaoNova, setFiscalizacaoNova] = useState(false);

    //State para editar a fiscalização
    const [fiscalizacao_id, setFiscalizacao_id] = useState(null);

    //Estado de controle dos erros nos campos
    const [errors, setErrors] = useState({});

    //Cabeçalhos da lista de fiscalização
    const headers = [
        { value: "Tipo de Serviço", objectValue: "tipoFiscalizacaoServico", align: "right" },
        { value: "Situação", objectValue: "situacao", align: "right" },
        {
            value: "Data de Cadastro", objectValue: "data", align: "right", options: {
                customBodyRenderLite: (dataIndex) => {
                    return <>{moment(listaFiscalizacao[dataIndex]?.data).format("DD/MM/YYYY")}</>
                }
            }
        },
        { value: "Endereço", objectValue: "endereco", align: "right" },
        {
            value: "Prazo para Execução", objectValue: "dataLimiteExecucao", align: "right", options: {
                customBodyRenderLite: (dataIndex) => {
                    return <>{moment(listaFiscalizacao[dataIndex]?.dataLimiteExecucao).format("DD/MM/YYYY")}</>
                }
            }
        },
        { value: "Origem", objectValue: "origem", align: "right" }
    ];

    const loadTipoDeFiscalizacao = () => {
        setLoading(true);
        tipoDeFiscalizacao_api.getListAtivos()
            .then(response => {
                response.data.map(value => {
                    value.value = value.id;
                    value.label = value.identificacao;
                    return value;
                })
                setListTipoDeFiscalizacao(response.data)
            })
            .catch(err => showMessage("Error", err?.message ?? "Error na operação.", "error", null))
            .finally(() => setLoading(false));
    };

    useEffect(() => {
        loadTipoDeFiscalizacao();
        if (filtros) {
            setConsultaFiscalizacao({ ...filtros })
            handleFiscalizacao(filtros);
        }
    }, []);

    //Campos obrigatorios
    const camposConsulta = [
        objCampo({ name: "tipoFiscalizacao_id", required: true }),
        objCampo({ name: "dataInicial", required: true }),
        objCampo({ name: "dataFinal", required: true })
    ]

    const editar = (fiscalizacao) => {
        navigate("ficha-demanda", { state: { id: fiscalizacao.id, filtros: { ...consultaTipoFiscalizacao }, btnVoltar: "/admin/demandas" } })
        setFiscalizacao_id(fiscalizacao.id);
    }

    //Ações que a tabela terá
    const actions = [actionsTable.editar(editar)];

    const onChangeSearchable = (value, e) => {
        const _consultaTipoFiscalizacao = {
            ...consultaTipoFiscalizacao,
            [e.name]: value ? value.value.toString() : null,
        };

        const _campos = camposConsulta.filter(campo => campo.name === e.name);
        const fieldError = validarCampos(_consultaTipoFiscalizacao, _campos);

        const _errors = { ...errors };
        delete _errors[e.name];
        if (fieldError[1].length === 0)
            setErrors({ ..._errors });
        else
            setErrors({ ..._errors, ...fieldError[0] });

        setConsultaFiscalizacao(_consultaTipoFiscalizacao);
    }

    //onChange para os campos que n são select com pesquisa ou multiplo
    const onChangeCampos = (e) => {
        const { name, value } = e.target;
        setConsultaFiscalizacao({
            ...consultaTipoFiscalizacao,
            [name]: value
        })
    }
    const handleFiscalizacao = (filtros = null) => {
        if (!filtros) {

            const _errors = validarCampos(consultaTipoFiscalizacao, camposConsulta);
            setErrors(_errors[0]);

            if (_errors[1].length > 0)
                return true;
        }

        const _consultaTipoFiscalizacao = { ...consultaTipoFiscalizacao }

        setLoading(true)
        solicitacaoFiscalizacao_api.getList(filtros ? filtros : _consultaTipoFiscalizacao)
            .then(response => {
                // fazer a chamada na API
                setListaFiscalizacao(response.data);
            })
            .catch(err => showMessage("Error", err?.message ?? "Error na operação.", "error", null))
            .finally(() => setLoading(false))
    }

    const handleVoltar = () => {
        setFiscalizacao_id(null);
        setFiscalizacaoNova(false);
        loadTipoDeFiscalizacao();
        handleFiscalizacao();
    }

    if (fiscalizacao_id || fiscalizacaoNova) {
        return <SolicitacaoFiscalizacaoStepper
            id={fiscalizacao_id}
            handleVoltar={handleVoltar}
        />
    }

    return <>
        <div className='d-flex align-items-center justify-content-between'>
            <h4 className='text-secondary m-0'>Demandas</h4>
            <Button color='success' className='mb-2 text-end' onClick={() => navigate("ficha-demanda")}>
                + Cadastrar
            </Button>
        </div>

        <Row className={`mt-3 formContainer`}>
            <Col md="12" lg="6">
                <TextField
                    type={"select"}
                    name={"tipoFiscalizacao_id"}
                    label={"* Tipo de fiscalização"}
                    searchable
                    options={listTipoDeFiscalizacao}
                    onChange={onChangeSearchable}
                    value={listTipoDeFiscalizacao.filter(value => value.value == consultaTipoFiscalizacao.tipoFiscalizacao_id)}
                    invalid={!!errors.tipoFiscalizacao_id}
                />
            </Col>
            <Col md="12" lg="6">
                <TextField
                    type={"select"}
                    name={"situacao"}
                    label={"Situação"}
                    searchable
                    options={optionsSituacao}
                    onChange={onChangeSearchable}
                    value={optionsSituacao.filter(value => value.value == consultaTipoFiscalizacao.situacao)}
                    invalid={!!errors.situacao}
                    placeholder='TODOS'
                />
            </Col>
            <Col md="12" lg="6">
                <TextField
                    type={"date"}
                    name={"dataInicial"}
                    label={"* Data inicial"}
                    onChange={onChangeCampos}
                    value={consultaTipoFiscalizacao.dataInicial}
                    invalid={!!errors.dataInicial}
                />
            </Col>
            <Col md="12" lg="6">
                <TextField
                    type={"date"}
                    name={"dataFinal"}
                    label={"* Data final"}
                    onChange={onChangeCampos}
                    value={consultaTipoFiscalizacao.dataFinal}
                    invalid={!!errors.dataFinal}
                />
            </Col>
            <Col md="12" lg="12" className='d-flex align-items-center justify-content-center'>
                <Button
                    color='primary'
                    className='mb-2 ms-3 px-4'
                    onClick={() => handleFiscalizacao()}
                >
                    <FontAwesomeIcon icon={faFilter} /> Filtrar
                </Button>
            </Col>
        </Row>

        <Row>
            <Col md={12} lg={12}>
                <TabelaListagem
                    actions={actions}
                    title={"Lista de demandas"}
                    headers={headers}
                    items={listaFiscalizacao}
                />
            </Col>
        </Row>
    </>;
}

export default SolicitacaoFiscalizacao;